import {Injectable, OnInit} from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { Subject } from 'rxjs/Subject';

import { Alert } from '../models/Alerts';

@Injectable()
export class AlertService implements OnInit {
  private subject = new Subject<Alert>();

  constructor() {
  }

  getAlert(): Observable<any> {
    return this.subject.asObservable();
  }

  success(message: string) {
    this.alert('success', message);
  }

  error(message: string) {
    this.alert('danger', message);
  }

  info(message: string) {
    this.alert('info', message);
  }

  warn(message: string) {
    this.alert('warning', message);
  }


  alert(type: string, message: string) {
    this.subject.next(<Alert>{ type: type, msg: message, title: ''});
  }

  clear() {
    this.subject.next();
  }

  ngOnInit () {

  }
}



// WEBPACK FOOTER //
// /home/gitlab-runner/builds/MZoVYbaM/0/has-gas/lora-wan/lora-ui/src/app/services/alert.service.ts